import { render, staticRenderFns } from "./Sgc.vue?vue&type=template&id=a7730888&"
import script from "./Sgc.vue?vue&type=script&lang=js&"
export * from "./Sgc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports